(function () {
  var root = document.querySelector('[data-byo-collection]');
  if (!root) return;

  // Filter drawer open/close
  var drawer = root.querySelector('[data-filter-drawer]');
  var toggleBtn = root.querySelector('[data-filter-toggle]');
  var closeEls = root.querySelectorAll('[data-filter-close]');

  function openDrawer() {
    drawer.setAttribute('data-open', '');
    drawer.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.removeAttribute('data-open');
    drawer.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
  }
  if (toggleBtn) toggleBtn.addEventListener('click', openDrawer);
  closeEls.forEach(function (el) { el.addEventListener('click', closeDrawer); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeDrawer();
  });

  // Sort select: keep the hidden sort_by input inside the filter form in sync,
  // then auto-submit that form so sort + any active filters apply together.
  var sortSelect = root.querySelector('[data-sort-select]');
  var sortHidden = root.querySelector('[data-sort-hidden]');
  var filterForm = document.getElementById('byo-filter-form');
  if (sortSelect && filterForm) {
    sortSelect.addEventListener('change', function () {
      if (sortHidden) sortHidden.value = sortSelect.value;
      filterForm.submit();
    });
  }

  // Auto-submit on checkbox filter change (standard UX for list/boolean filters)
  root.querySelectorAll('[data-filter-input]').forEach(function (input) {
    input.addEventListener('change', function () {
      if (filterForm) filterForm.submit();
    });
  });

  // Active filter count badge
  var countBadge = root.querySelector('[data-active-filter-count]');
  if (countBadge && filterForm) {
    var activeCount = filterForm.querySelectorAll('input[type="checkbox"]:checked').length;
    var params = new URLSearchParams(window.location.search);
    params.forEach(function (value, key) {
      if (key.indexOf('filter.v.price') === 0) activeCount += 1;
    });
    if (activeCount > 0) {
      countBadge.textContent = activeCount;
      countBadge.hidden = false;
    }
  }

  // Toast notification
  function showToast(message) {
    var toast = root.querySelector('[data-byo-toast]');
    if (!toast) {
      toast = document.createElement('div');
      toast.setAttribute('data-byo-toast', '');
      toast.className = 'byo-col-toast';
      document.body.appendChild(toast);
    }
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(toast._hideTimer);
    toast._hideTimer = setTimeout(function () {
      toast.classList.remove('is-visible');
    }, 2200);
  }

  // Sync Shopify's real header cart icon badge (Horizon theme structure) —
  // ONLY update the count text. Do not toggle the --has-cart class: that
  // class controls a CSS mask that cuts a circular hole in the cart SVG for
  // the bubble to sit in, and toggling it without Shopify's own bubble
  // logic fully active can leave a visible "hole" with nothing filling it.
  function syncHeaderCartCount(cart) {
    var count = cart.item_count;
    var countText = count > 0 ? String(count) : '';
    document.querySelectorAll('.cart-bubble__text-count').forEach(function (el) {
      el.textContent = countText;
    });
    ['[data-cart-count]', '.cart-count-bubble', '[data-header-cart-count]'].forEach(function (sel) {
      document.querySelectorAll(sel).forEach(function (el) { el.textContent = count; });
    });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
    document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { cart: cart } }));
  }

  // Quick add — adds default/first available variant directly from the grid
  root.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-quick-add-btn]');
    if (!btn) return;
    event.preventDefault();
    event.stopPropagation();

    var variantId = btn.dataset.variantId;
    if (!variantId) {
      window.location.href = btn.dataset.productUrl;
      return;
    }

    var productName = btn.closest('.byo-col-card')?.querySelector('.byo-col-card__title')?.textContent?.trim();

    // Detect whether the cart was empty before this click. If so, Shopify's
    // own header bubble system was never activated — a plain text update
    // can't make the bubble appear for the very first item; only a real page
    // load runs that initialization. So we reload ONLY in that one case, and
    // stay AJAX-only (no reload) for every other add.
    var cartIconEl = document.querySelector('cart-icon.header-actions__cart-icon');
    var cartWasEmpty = cartIconEl ? !cartIconEl.classList.contains('header-actions__cart-icon--has-cart') : false;

    btn.disabled = true;
    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: 1 }),
    })
      .then(function (res) {
        if (!res.ok) throw new Error('add failed');
        if (cartWasEmpty) {
          window.location.reload();
          return null;
        }
        btn.classList.add('is-added');
        btn.innerHTML = '<svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.5" stroke-linecap="round" stroke-linejoin="round"><polyline points="20 6 9 17 4 12"/></svg>';
        showToast(productName ? '✓ Added "' + productName + '" to cart' : '✓ Added to cart');
        return fetch('/cart.js');
      })
      .then(function (res) { return res && res.json(); })
      .then(function (cart) {
        if (cart) syncHeaderCartCount(cart);
      })
      .catch(function () {
        window.location.href = btn.dataset.productUrl;
      })
      .finally(function () {
        setTimeout(function () {
          btn.disabled = false;
          btn.classList.remove('is-added');
          btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="5" x2="12" y2="19"/><line x1="5" y1="12" x2="19" y2="12"/></svg>';
        }, 1800);
      });
  });
})();